import { i18n } from "#ce/components/SpFinder/i18n";
/** Reads map wording from the deferred finder catalog. */
export function mapText(key, values) {
  return i18n.global.t(`map.${key}`, values ?? {});
}
